import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IStyleProps {
  bgColor?: string;
}

export const Root = styled.div`
  flex-grow: 1;
  background-color: ${(props: IStyleProps) => (props.bgColor ?? C.GENERIC_GRAY)};
  box-sizing: border-box;
  padding: 11px 0px 11px 0px;
  font-family: Roboto;
`;

export const Title = styled.label`
  height: 50px;
  width: 216px;
  display: block;
  flex-grow: 0;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.5;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.5);
  padding-left: 20px;
`;

export const Layers = styled.div`
  display: block;
  width: 100%;
`;